<template>
  <div class="page page__list">
    <div class="nav">
      <span
        :class="selected1 == '生产日报分析' ? 'selected1' : ''"
        @click="toggle1('生产日报分析')"
        >生产日报分析</span
      >
      <span>|</span>
      <span
        :class="selected1 == '生产日报表' ? 'selected1' : ''"
        @click="toggle1('生产日报表')"
        >生产日报表</span
      >
    </div>

    <div v-show="selected1 == '生产日报分析'">
      <div class="filter-bar">
        <span @click="selectYearmonth">
          {{ yearmonth }}
          <i class="caret"></i>
        </span>
        <span>
          {{ querytype }}
          <i class="caret"></i>
          <select
            class="filter-item__select"
            v-model="querytype"
            @change="searchMakeHourMonth"
          >
            <option :value="'物料'">物料</option>
            <option :value="'工作中心'">工作中心</option>
          </select>
        </span>
      </div>

      <div class="canvas-box">
        <canvas id="myChart" class="myChart"></canvas>
      </div>

      <!-- <div class="list-box">
        <search-bar
          v-if="querytype === '物料'"
          @search="searchMakeHourMonth"
          name="pr_code,pr_detail,pr_orispeccode,pr_brand"
          placeholder="输入物料进行查找"
          ref="searchBar1"
        />
        <div class="weui-cells">
          <div
            class="weui-cell weui-cell_access"
            v-for="(item, index) in result.details"
            :key="index"
            @click="onChangeChart(item)"
          >
            <div class="weui-cell__bd">
              <p v-if="querytype === '物料'">{{item.pr_code}} {{ item.pr_detail }}</p>
              <p v-if="querytype === '工作中心'">{{item.wc_name }}</p>
            </div>
            <div class="weui-cell__ft">
              <p>{{item.qty}}</p>
            </div>
          </div>
        </div>
      </div> -->

      <div class="list-box" v-if="querytype == '物料'">
        <div
          class="list-cell"
          v-for="(item, index) in result.details"
          :key="index"
        >
          <div class="list-cell__main" @click="open('opened', index)">
            <div class="list-cell__index">
              <span>{{ index + 1 }}</span>
            </div>
            <div class="list-cell__content">
              {{ item.pr_code }} {{ item.pr_detail }}
            </div>
            <div class="list-cell__toggle">
              <span v-if="opened == index"
                ><i class="iconfont icon-shang"></i
              ></span>
              <span v-else><i class="iconfont icon-xia"></i></span>
            </div>
          </div>
          <div class="weui-cells" v-if="opened == index">
            <div class="weui-cell gray" v-for="day in result.days" :key="day">
              <div class="weui-cell__bd">{{ day }}日</div>
              <div class="weui-cell__ft">{{ item["qty" + day] }}</div>
            </div>
            <div class="weui-cell gray">
              <div class="weui-cell__bd">本月累计</div>
              <div class="weui-cell__ft">{{ item.qty }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="list-box scroll-box" v-if="querytype == '工作中心'">
        <div class="scroll-fixed">
          <div class="list-cell">
            <div class="list-cell__main">
              <div class="list-cell__index"></div>
              <div class="list-cell__content" style="font-weight: bold">
                工作中心&物料
              </div>
              <div class="list-cell__ft"></div>
              <div class="list-cell__toggle"></div>
            </div>
          </div>
          <div
            class="list-cell"
            v-for="(wc, wc_i) in result.details"
            :key="wc_i"
          >
            <div class="list-cell__main" @click="open('opened1', wc_i)">
              <div class="list-cell__index">
                <span>{{ wc_i + 1 }}</span>
              </div>
              <div class="list-cell__content">{{ wc.wc_name }}</div>
              <div class="list-cell__ft">{{ wc.qty }}</div>
              <div class="list-cell__toggle">
                <span v-if="opened1 == wc_i"
                  ><i class="iconfont icon-shang"></i
                ></span>
                <span v-else><i class="iconfont icon-xia"></i></span>
              </div>
            </div>

            <div v-if="opened1 == wc_i && wc.children">
              <div
                class="list-cell"
                v-for="(prod, prod_i) in wc.children"
                :key="prod_i"
              >
                <div class="list-cell__main">
                  <div class="list-cell__index" style="margin-left: 15px">
                    <span>{{ prod_i + 1 }}</span>
                  </div>
                  <div class="list-cell__content">
                    {{ prod.pr_code }} {{ prod.pr_detail }}
                  </div>
                  <div class="list-cell__ft">{{ prod.qty }}</div>
                  <div class="list-cell__toggle"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="scroll-scrollable">
          <div class="scroll-scrollable-cell">
            <div
              class="scroll-scrollable-cell__day"
              style="font-weight: bold"
              v-for="day in result.days"
              :key="day"
            >
              {{ day + "日" }}
            </div>
          </div>
          <div
            class="scroll-scrollable-cell"
            v-for="(scrollItem, si) in scrollList"
            :key="si"
          >
            <div
              class="scroll-scrollable-cell__day"
              v-for="day in result.days"
              :key="day"
            >
              {{ scrollItem["qty" + day] || 0 }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="selected1 == '生产日报表'">
      <search-bar
        @search="onSearch"
        name="pr_code,pr_detail,pr_orispeccode,ma_code"
        placeholder="输入产品、单号进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          :to="{
            name: 'ProductionMakeHourReportDetail',
            params: { initData: item },
          }"
        >
          <div class="weui-cell__bd">
            <p>{{ item.ma_code }}</p>
            <p class="list-item-muted" v-format="'yyyy-MM-dd'">
              {{ item.mh_date }}
            </p>
          </div>
          <div class="weui-cell__ft">
            <p>{{ item.pr_detail }}</p>
            <span class="list-item-muted">{{ item.ma_kind }}</span>
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{ items.length }}单</label>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";
import F2 from "@antv/f2/lib/index";
import ScrollBar from "@antv/f2/lib/plugin/scroll-bar";
import "@antv/f2/lib/interaction/pan";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
  },
  mixins: [list],
  data() {
    let year = new Date().getFullYear();
    let month = new Date().getMonth() + 1;
    let yearmonth = "" + year + (month < 10 ? "0" + month : month);

    return {
      result: {
        details: [],
      },
      selected1: "生产日报分析",
      yearmonth,
      querytype: "物料",
      querytypeObj: {
        物料: "prod",
        工作中心: "workcenter",
      },
      listUrl: "/api/make/report/makehour",
      params: {
        mode: "DETAIL",
      },
      filters: [
        {
          type: "date",
          name: "mh_date",
        },
      ],
      opened: -1,
      opened1: -1,
      chart: null,
    };
  },
  mounted() {
    this.searchMakeHourMonth();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    if (this.chart) {
      this.chart.destroy();
    }
  },
  computed: {
    scrollList() {
      if (this.opened1 < 0) {
        return this.result.details;
      } else {
        return this.result.details.toSpliced(
          this.opened1 + 1,
          0,
          ...this.result.details[this.opened1].children
        );
      }
    },
  },
  methods: {
    searchMakeHourMonth() {
      let me = this;

      let searchBar1 = me.$refs.searchBar1;
      let keyword = searchBar1 && searchBar1.keyword;

      const params = {
        yearmonth: me.yearmonth,
        querytype: me.querytypeObj[me.querytype],
      };
      if (keyword) {
        params.con = `(pr_code like '%${keyword}%' or pr_detail like '%${keyword}%' or pr_orispeccode like '%${keyword}%' or pr_brand like '%${keyword}%')`;
      }

      me.$ajax({
        url: "/api/make/report/makehourMonth",
        params,
      }).then(function (res) {
        if (res.success) {
          me.result = res.data;
          me.initChart(me.deal(me.result.monthitems));
        }
      });
    },
    onResize() {
      var chart = this.chart;
      if (chart) {
        this.chart = chart.destroy();
        this.initChart(this.deal(this.result.monthitems));
      }
    },
    initChart(data) {
      var chart = this.chart;
      if (chart) {
        chart.changeData(data);
        return;
      }
      this.chart = chart = new F2.Chart({
        id: "myChart",
        width: window.innerWidth,
        height: Math.min(window.innerHeight * 0.6, 300),
        pixelRatio: window.devicePixelRatio,
        plugins: ScrollBar,
      });

      chart.source(data, {
        index: {
          type: "linear",
          tickInterval: 1,
          min: -1,
          max: window.innerWidth > window.innerHeight ? 21 : 12,
          formatter: (i) =>
            i > -1 && i < 31
              ? [
                  "1日",
                  "2日",
                  "3日",
                  "4日",
                  "5日",
                  "6日",
                  "7日",
                  "8日",
                  "9日",
                  "10日",
                  "11日",
                  "12日",
                  "13日",
                  "14日",
                  "15日",
                  "16日",
                  "17日",
                  "18日",
                  "19日",
                  "20日",
                  "21日",
                  "22日",
                  "23日",
                  "24日",
                  "25日",
                  "26日",
                  "27日",
                  "28日",
                  "29日",
                  "30日",
                  "31日",
                ][i]
              : null,
        },
      });

      chart
        .interval()
        .position("index*value")
        .color("type", (val) => {
          if (val === "数量") {
            return "#2eadf5";
          } else {
            return "#2eadf5";
          }
        })
        .adjust({
          type: "dodge",
          marginRatio: 0.05, // 设置分组间柱子的间距
        });
      // 定义进度条
      chart.scrollBar({
        mode: "x",
        xStyle: {
          backgroundColor: "#e8e8e8",
          fillerColor: "#808080",
          offsetY: -2,
        },
      });
      chart.interaction("pan");
      chart.render();
    },
    deal(data) {
      if (!data) return;

      let arr = [
        { index: -1, type: "数量", value: 0 },
        { index: 31, type: "数量", value: 0 },
      ];

      for (let i = 0; i < 31; i++) {
        arr.push({
          text: data[i]?.text || "",
          type: "数量",
          index: i,
          value: data[i]?.qty || 0,
        });
      }

      return arr;
    },
    deal2(data) {
      if (!data) return;
      let arr = [
        { index: -1, type: data.text, value: 0 },
        { index: 31, type: data.text, value: 0 },
      ];
      for (let i = 0; i < 31; i++) {
        arr.push({
          index: i,
          text: i + "日",
          type: data?.text,
          value: data["qty" + (i + 1)] || 0,
        });
      }
      return arr;
    },
    onChangeChart(item) {
      let arr = [];
      for (let i = 0; i < item.days; i++) {
        arr[i] = {
          text: i + 1 + "日",
          day: i + 1,
          qty: item["qty" + (i + 1)] || 0,
        };
      }
      this.initChart(arr);
    },
    toggle1(val) {
      this.selected1 = val;

      if (val == "生产日报分析") {
        this.searchMakeHourMonth();
      } else if (val == "生产日报表") {
        // this.search()
      }
    },
    open(opened, index) {
      if (index != this[opened])
        this.initChart(this.deal2(this.result.details[index]));

      this[opened] = index == this[opened] ? -1 : index;
    },
    selectYearmonth() {
      var me = this,
        year = new Date().getFullYear(),
        years = [],
        months = [
          { value: "01", label: "1月" },
          { value: "02", label: "2月" },
          { value: "03", label: "3月" },
          { value: "04", label: "4月" },
          { value: "05", label: "5月" },
          { value: "06", label: "6月" },
          { value: "07", label: "7月" },
          { value: "08", label: "8月" },
          { value: "09", label: "9月" },
          { value: "10", label: "10月" },
          { value: "11", label: "11月" },
          { value: "12", label: "12月" },
        ];
      for (let i = year - 20, len = year + 20; i <= len; i++) {
        years.push({
          value: i,
          label: i + "年",
        });
      }
      me.$weui.picker(years, months, {
        title: "选择年月",
        onConfirm: function (r) {
          me.yearmonth = r[0].value + r[1].value;
          me.searchMakeHourMonth();
        },
      });
    },
  },
};
</script>

<style scoped>
.nav {
  padding: 10px 20px;
  display: flex;
  justify-content: space-around;
  background: var(--weui-BG);
}
.nav .selected1 {
  color: #38559f;
}

.canvas-box {
  /* width: 200%; */
  overflow-x: scroll;
  /* height: 100%; */
  background: var(--weui-BG);
}

.filter-bar {
  width: 100%;
  background: var(--weui-BG-2);
  box-sizing: border-box;
  text-align: center;
  font-size: 13px;
  padding: 11px 0 9px 0;
  color: #9b9b9b;
  margin-bottom: 1px;
  display: flex;
}
.filter-bar span {
  margin: 0 auto;
  flex: 1;
  position: relative;
}
.filter-item__select {
  position: absolute;
  margin: 0;
  padding: 0;
  border: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.filter-item__select option {
  color: var(--weui-FG-0);
  background: var(--weui-BG-2);
}

.list-box {
  margin-top: 5px;
  background: var(--weui-BG);
}
.list-cell {
  background-color: #fff;
}
.list-cell__main {
  display: flex;
}
.list-cell__index {
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.list-cell__index span {
  border-radius: 50%;
  width: 20px;
  height: 20px;
  color: #fff;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  background-color: #c0c0c0;
}
.list-cell__content {
  flex: 1;
  height: 56px;
  line-height: 56px;
  font-size: 12px;
  color: #8b8b8b;

  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.list-cell__ft {
  color: var(--weui-FG-1);
  font-size: 14px;
  line-height: 56px;
  padding: 0 5px;
}
.list-cell__toggle {
  width: 20px;
  height: 56px;
  line-height: 56px;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  padding: 0 5px;
}
.gray {
  background: #f4f4f4;
}

.scroll-box {
  display: flex;
}
.scroll-fixed {
  width: 200px;
  border-right: 1px solid var(--weui-FG-3);
}
.scroll-scrollable {
  flex: 1;
  overflow-x: scroll;
}
.scroll-scrollable-cell {
  height: 56px;
  line-height: 56px;
  display: flex;
}
.scroll-scrollable-cell__day {
  flex: 0 0 70px;
  font-size: 14px;
  color: var(--weui-FG-1);
  text-align: center;
}
@media screen and (min-width: 500px) {
  .nav {
    display: none;
  }
  .filter-bar {
    padding: 6px 0 2px 0;
  }
  .scroll-scrollable-cell {
    height: 26px;
    line-height: 26px;
  }
  .list-cell__toggle {
    height: 26px;
    line-height: 26px;
  }
  .list-cell__content{
    height: 26px;
    line-height: 26px;
  }
  .list-cell__ft{
    line-height: 26px;
  }
  .scroll-scrollable-cell__day{
    flex: 0 0 52px;
  }
}
</style>